// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6857 ? "76572126" : chunkId) + "." + {"6857":"f8ce0d8864340707","9427":"2a7bdd85f3263c3a"}[chunkId] + ".js";
};